import { onAnnualPlanDeselect, onAnnualPlanSelect } from '../../shared';
import { setLocalItem } from '../../store/localStore';
import { ANNUAL_COVER_VALUE } from '../../../constants';
import { dateDiffInDays, getThreeMonthsFromNow } from '../../../utils';
export function coverTypeEventManager(form, startPicker, endPicker) {
    // select all card option for cover type
    const coverTypeCards = document.querySelectorAll('.qq__card.cover-type');
    const destinationTypeCards = document.querySelectorAll('.qq__card.destination-type');
    const startDateInput = document.getElementById('start-date');
    coverTypeCards.forEach((card) => {
        card.addEventListener('click', (event) => {
            coverTypeCards.forEach((card) => {
                card.classList.remove('active-card');
            });
            card.classList.add('active-card');
            card.scrollIntoView({ behavior: 'smooth', block: 'center' });
            document
                .getElementById('qq-cover-type')
                .classList.remove('error', 'required');
            const inputElement = card.querySelector('input[type="radio"]');
            if (inputElement) {
                const dataValue = inputElement.value;
                form.set('coverType', dataValue);
                setLocalItem('coverType', dataValue);
                if (dataValue === ANNUAL_COVER_VALUE) {
                    onAnnualPlanSelect();
                    const today = new Date().toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                    });
                    const isOverThreeMonths = startDateInput.value &&
                        dateDiffInDays(today, startDateInput.value) > 88;
                    if (isOverThreeMonths) {
                        startDateInput.value = '';
                        setLocalItem('startDate', '');
                        form.set('startDate', '');
                        startPicker.clear();
                    }
                    updateDatePickers(startPicker, endPicker);
                    if (form.get('area') == 'K' || form.get('area') == 'A') {
                        form.set('area', '');
                        destinationTypeCards.forEach((card) => {
                            card.classList.remove('active-card');
                        });
                    }
                    if (form.get('startDate') != '' && startDateInput.value == '') {
                        form.set('startDate', '');
                    }
                }
                else {
                    onAnnualPlanDeselect();
                    updateDatePickersForYear(startPicker, endPicker);
                }
            }
        });
    });
}
function updateDatePickers(startPicker, endPicker) {
    const now = new Date();
    const threeMonthsFromNow = getThreeMonthsFromNow();
    if (startPicker) {
        const currentStartDate = startPicker.selectedDates
            ? startPicker.selectedDates[0]
            : null;
        startPicker.update({
            minDate: now,
            maxDate: threeMonthsFromNow,
        });
        // Re-select the current date if it exists and is within the new range
        if (currentStartDate &&
            currentStartDate >= now &&
            currentStartDate <= threeMonthsFromNow) {
            startPicker.selectDate(currentStartDate);
        }
    }
    if (endPicker) {
        const currentEndDate = endPicker.selectedDates
            ? endPicker.selectedDates[0]
            : null;
        endPicker.update({
            minDate: now,
            maxDate: threeMonthsFromNow,
        });
        // Re-select the current date if it exists and is within the new range
        if (currentEndDate &&
            currentEndDate >= now &&
            currentEndDate <= threeMonthsFromNow) {
            endPicker.selectDate(currentEndDate);
        }
    }
}
function updateDatePickersForYear(startPicker, endPicker) {
    const now = new Date();
    const oneYearFromNow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 364);
    const startDateInput = document.getElementById('start-date');
    const endDateInput = document.getElementById('end-date');
    if (startPicker) {
        const currentStartDate = startPicker.selectedDates
            ? startPicker.selectedDates[0]
            : null;
        startPicker.update({
            minDate: now,
            maxDate: oneYearFromNow,
        });
        // Re-select the current date if it exists and is within the new range
        if (currentStartDate &&
            currentStartDate >= now &&
            currentStartDate <= oneYearFromNow) {
            startPicker.selectDate(new Date(currentStartDate));
            const formattedDate = currentStartDate.toLocaleString('it-IT', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            });
            startDateInput.value = formattedDate;
        }
    }
    if (endPicker) {
        const currentEndDate = endPicker.selectedDates
            ? endPicker.selectedDates[0]
            : null;
        endPicker.update({
            minDate: now,
            maxDate: oneYearFromNow,
        });
        // Re-select the current date if it exists and is within the new range
        if (currentEndDate &&
            currentEndDate >= now &&
            currentEndDate <= oneYearFromNow) {
            endPicker.selectDate(currentEndDate);
            const formattedDate = currentEndDate.toLocaleString('it-IT', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            });
            endDateInput.value = formattedDate;
        }
    }
}
